// eslint-disable-next-line no-unused-vars
export const formOrderObjFromCart = (data = null, osType = 'Windows', serverType = null, sku = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const dataDisks = data?.itemDetail?.catalogService?.catalogConfig?.diskDefinitions || null;
    const os = data?.itemDetail?.catalogService?.catalogConfig?.os || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;

    const getDataDisks = () => {
        const modifiedDisks = dataDisks?.map((item) => ({
            // eslint-disable-next-line
            diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
            diskDriveLetter: item?.diskDriveLetter || '',
            fsType: item?.fsType ? item?.fsType : 'NTFS',
            diskSizeInGib: item?.diskSizeInGib,
        }));
        return modifiedDisks;
    };

    const costCenter = entityDetails?.costCenter || environmentDetails?.costCenter || null;

    return {
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: costCenter,
            projectName: entityDetails?.project || environmentDetails?.projectName,
        },
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: data?.itemDetail?.catalogService?.sector || null,
        billingEntity: catalogConfig?.billingEntity || null,
        hCode: costCenter,
        ...(costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        landingZoneDetails: {
            id: environmentDetails?.landingZoneId,
        },

        // Resource Section
        resourceGroup: environmentDetails?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: environmentDetails?.subscription || null,
        subscriptionDetails: {
            subscriptionId: environmentDetails?.subscriptionId,
            subscriptionName: environmentDetails?.subscription,
        },
        vnetDR: environmentDetails?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: environmentDetails?.subNetName || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        osVersionDetail: os || null,
        osType: os?.osType || 'Windows',
        osDiskType: os?.osDiskType || null,
        osDiskTypeCode: os?.osDiskTypeCode || null,
        sku,
        vmType: catalogConfig?.vmType || null,
        vmTypeDetails: catalogConfig?.vmType
            ? {
                  name: catalogConfig?.vmType,
                  displayName: catalogConfig?.vmType,
                  acceleratedNetworkingSupported: catalogConfig?.acceleratedNetworking === true || catalogConfig?.acceleratedNetworking === 'yes',
                  ephemeralDiskAvailable: os?.ephemeralDiskAvailable || false,
                  maxDataDiskCount: catalogConfig?.maxDataDiskCount || null,
                  ...(environmentDetails?.availabilityZones && { availabilityZones: environmentDetails?.availabilityZones }),
              }
            : null,
        maxDataDiskCount: catalogConfig?.maxDataDiskCount || null,
        dataDisksCount: dataDisks?.length || 0,
        dataDisks: getDataDisks() || [],
        domain: environmentDetails?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        adGroup: catalogConfig?.adGroup || '',
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            availabilityZoneOptions: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        quantity: data?.itemDetail?.catalogService?.quantity,
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        timeZone: data?.itemDetail?.catalogService?.timeZone,
        hoursOfOperation: data?.itemDetail?.catalogService?.hoursOfOperation || null,
        estimatedCost: data?.itemDetail?.catalogService?.estimatedCost || null,
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true || catalogConfig?.acceleratedNetworking === 'yes' ? 'yes' : 'no',

        serverType,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

// eslint-disable-next-line no-unused-vars
export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null, osType = 'Windows', serverType = null, sku = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const dataDisks = catalogConfig?.diskDefinitions || null;
    const os = catalogConfig?.os || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;

    const getDataDisks = () => {
        const modifiedDisks = dataDisks?.map((item) => ({
            // eslint-disable-next-line
            diskType: item?.diskType ? item?.diskType : ['Production'].includes(environmentDetails?.environment) ? 'Premium SSD' : 'Standard SSD',
            diskDriveLetter: item?.diskDriveLetter || '',
            fsType: item?.fsType ? item?.fsType : 'NTFS',
            diskSizeInGib: item?.diskSizeInGib,
        }));
        return modifiedDisks;
    };

    return {
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: {
                    applicationServices: [{ businessCriticality: catalogConfig?.appBusinessCriticality }],
                    dataClassification: catalogConfig?.tags?.['pep-dataclassification'],
                },
            },
        }),
        ...(!entityDetails?.name && { appProfileDetails: null }),
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        entityDetails: {
            ...entityDetails,
            owner: { name: entityDetails?.applicationManager, emailId: entityDetails?.applicationManagerEmail, id: entityDetails?.applicationManagerGpid },
            financialDetails: environmentDetails?.costCenter,
            projectName: environmentDetails?.projectName,
            billingEntity: catalogConfig?.billingEntity,
            sector: catalog?.sector,
        },
        tagsQc: { ...catalogConfig?.tags },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        sector: catalog?.sector || null,
        billingEntity: catalogConfig?.billingEntity || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        environment: environmentDetails?.environment || null,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        region: environmentDetails?.region || null,
        landingZoneDetails: {
            id: environmentDetails?.landingZoneId,
        },

        // Resource Section
        resourceGroup: environmentDetails?.resourceGroup || null,
        resourceGroupDetails: null,
        subscription: environmentDetails?.subscription || null,
        subscriptionDetails: {
            subscriptionId: environmentDetails?.subscriptionId,
            subscriptionName: environmentDetails?.subscription,
        },
        vnetDR: environmentDetails?.virtualNetwork || null,
        vnetDRDetails: environmentDetails?.virtualNetworkId ? { data: { vnetId: environmentDetails?.virtualNetworkId } } : null,
        subnetDR: environmentDetails?.subNetName || null,
        osVersion: os?.publisher ? `${os?.publisher},${os?.sku}` : null,
        osVersionDetail: os || null,
        osType: os?.osType || 'Windows',
        osDiskType: os?.osDiskType || null,
        osDiskTypeCode: os?.osDiskTypeCode || null,
        sku,
        vmType: catalogConfig?.vmType || null,
        vmTypeDetails: catalogConfig?.vmType
            ? {
                  name: catalogConfig?.vmType,
                  displayName: catalogConfig?.vmType,
                  acceleratedNetworkingSupported: catalogConfig?.acceleratedNetworking === true || catalogConfig?.acceleratedNetworking === 'yes',
                  ephemeralDiskAvailable: os?.ephemeralDiskAvailable || false,
                  maxDataDiskCount: catalogConfig?.maxDataDiskCount || null,
                  ...(environmentDetails?.availabilityZones && { availabilityZones: environmentDetails?.availabilityZones }),
              }
            : null,
        maxDataDiskCount: catalogConfig?.maxDataDiskCount || null,
        dataDisksCount: dataDisks?.length || 0,
        dataDisks: getDataDisks() || [],
        domain: environmentDetails?.domain || null,
        adousDefault: environmentDetails?.adOu || 'Default OU',
        adGroup: catalogConfig?.adGroup || '',
        ...(environmentDetails?.availabilityZones && {
            haDeployment: 'Availability Zones',
            availabilityZone: environmentDetails?.availabilityZones,
            availabilityZoneOptions: environmentDetails?.availabilityZones,
            isValidAvailabilityZone: true,
        }),
        ...(environmentDetails?.availabilitySet && {
            haDeployment: 'Availability Set',
            isValidAvailabilityZone: true,
        }),
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        acceleratedNetworking: catalogConfig?.acceleratedNetworking === true || catalogConfig?.acceleratedNetworking === 'yes' ? 'yes' : 'no',
        quantity: catalog?.quantity,
        ...(environmentDetails?.environment === 'Production' && {
            azureSiteRecovery: catalogConfig?.azureSiteRecovery ? 'yes' : 'no',
        }),
        timeZone: catalog?.timeZone,
        hoursOfOperation: catalog?.hoursOfOperation || null,
        estimatedCost: catalog?.estimatedCost || null,

        serverType,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    appProfile: null,
    appProfileDetails: null,
    entityDetails: null,
    businessCategory: null,
    environment: null,
    appTier: null,
    appTierCode: null,
    microService: null,
    microServiceDetails: null,
    region: null,
    regionDisplayName: null,
    landingZone: null,
    landingZoneDetails: null,
    envDetails: null,
    environmentDetailsDisplay: null,
    osVersion: null,
    osVersionDetail: null,
    osDiskType: null,
    vmType: null,
    vmTypeDetails: null,
    quantity: 1,
    maxDataDiskCount: null,
    dataDisksCount: null,
    dataDisks: [],
    defaultDataDisks: [],
    adGroup: null,
    timeZone: 'UTC',
    timeZoneDetail: null,
    domain: null,
    domainDetails: null,
    hCode: null,
    hCodeDetails: null,
    billingEntity: null,
    billingEntityDetails: null,
    adousDefault: null,
    adous: null,
    adousDetails: null,
    sector: null,
    sectorDetails: null,
    tags: [],
    tagsQc: null,
    appOwner: null,
    appOwnerDetails: null,
    estimatedCost: resetCostEstimateDetails,
    acceleratedNetworking: 'yes',
    serverRefresh: 'no',
    validationStatus: 'clearValidation',
    isTouched: false,
    haDeployment: null,
    availabilityZone: null,
    availabilityZoneOptions: [],
    isValidAvailabilityZone: true,
    retiringServerName: null,
    retiringServerSysId: null,
    disposalReason: null,
    scheduledRetirement: null,
    resourceGroup: null,
    resourceGroupDetails: null,
    azureSiteRecovery: 'no',
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isDiskOpen: false,
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isApplicationOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};
